<template>
  <div>
    <van-search
      v-model="keyword"
      show-action
      label="搜索"
      placeholder="请输入会员姓名或收货人"
      @search="onSearch"
    >
      <template #action>
        <div @click="onSearch">搜索</div>
      </template>
    </van-search>
    <div class="orders">

      <van-tabs v-model="active" @click="getOrders">
        <van-tab v-for="(type, index) in typeList" :key="index" :id="type.id" :title="type.name" :to="{ path: 'orders', query: { status: type.id }}" >

          <van-list>
            <div class="orders-li" v-for="(item, k) in list" :key="k">
              <div class="o-li-title">
                <span class="o-li-title-l">编号：{{ item.order_sn }}</span>
                <span class="o-li-title-r">客户ID:{{ item.merchant_id }}</span>
              </div>
              <div class="o-main">
                <div class="info">
                  <div class="price">
                    <span>会员ID:{{ item.user_id }}，姓名:{{ item.user_name }}<template v-if="item.order_info">，收货人:{{ item.order_info.real_name }}</template></span>
                    <span class="right sp2" v-if="item.order_info"><template v-if="item.order_info.order_class == 1">积分订单</template><template v-else>消费订单</template></span>
                  </div>
                </div>
              </div>
              <div class="o-bottom">
                <span class="item-time">日期：{{item.created_at}}</span>
                <span @click="goScan(item.id)" v-if="item.status == 0" >
                  <span class="o-wl">去发货扫码</span>
                </span>
                <!--
                <router-link :to="{ name: 'scan', query: { id: item.id }}" v-if="item.status == 0" >
                  <span class="o-wl">去发货扫码</span>
                </router-link>
                -->
                <!--
                <router-link :to="{ name: 'ordersShow', query: { id: item.id }}" v-if="item.status == 1">
                  <span class="o-wl">查看详情</span>
                </router-link>
                -->
                <div class="o-l-b" v-if="item.status == 1">
                  <van-collapse v-model="activeNames">
                    <van-collapse-item title="查看详情" :name="item.id">
                      <div class="order-show">
                        <div class="order-show-li">
                          <h3 class="h3">订单信息</h3>
                          <div class="o-s-li-m">
                            <span>订单编号：{{ item.order_sn }}</span>
                            <span>扫码日期：{{ item.updated_at }}</span>
                          </div>
                        </div>
                        <div class="order-show-li">
                          <h3 class="h3">绑定防伪码</h3>
                          <div class="o-s-address">
                            <p v-for="code in item.codes">防伪码：{{ code.code }}</p>
                          </div>
                        </div>
                      </div>
                    </van-collapse-item>
                  </van-collapse>
                </div>
              </div>
            </div>

          </van-list>
        </van-tab>
      </van-tabs>

    </div>
    <wxNoShare />
    <Footer />
  </div>
</template>

<script>
  import { Tab, Tabs, List, CountDown,Search, Collapse, CollapseItem } from 'vant';

  export default {
    components: {
      [List.name]: List,
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
      [CountDown.name]: CountDown,
      [Search.name]: Search,
      [Collapse.name]: Collapse,
      [CollapseItem.name]: CollapseItem,
    },
    name: 'orders',
    data() {
      return {
        activeNames: [],
        page: 1,
        active: 0,
        typeList: [
          {id: 0, name: '待发货'},
          {id: 1, name: '已发货'}
        ],
        list: [],
        listLength: 0,
        loading: true,
        finished: true,
        total: 0,
        title: '待发货',
        keyword: ''
      };
    },
    created() {
      let title = this.$route.query.title
      this.title = title
      switch (title) {
        case '待发货':
          this.active = 0
          break
        case '已发货':
          this.active = 1
          break
        default:
      }
      this.getOrders()
    },
    methods: {
      getOrders(name, title) {
        if(typeof title !== 'undefined'){
          this.title = title
        }
        if(this.active == 1 || this.keyword != ''){
          this.$api.get('fw/orders', {page: this.page, keyword: this.keyword, status: this.active}, r=>{
            this.list = r.result
            this.list.map((item)=>{
              item.type_name = '绀发'
              if(item.type == 1){
                item.type_name = '个人收益'
              }
            })
          })
        }else{
          this.list = []
        }
      },
      onSearch() {
        // this.$toast('搜索' + this.keyword)
        this.getOrders()
      },
      goScan(id) {
        document.location.href = '/orders/scan?id='+id;
      }
    }
  }
</script>

<style scoped>
  .orders-li{
    overflow: hidden;
    background: #ffffff;
    border-radius: 8px;
    margin: 10px;
    padding:15px;
  }
  .orders-li .o-li-title{
    font-size: 14px;
    overflow: hidden;
    margin-bottom: 10px;
  }
  .orders-li .o-li-title .o-li-title-l{
    float: left;
    font-weight: bold;
  }
  .orders-li .o-li-title .o-li-title-r{
    float: right;
    color: #ED6A0C;
  }
  .orders-li .o-main{
    overflow: hidden;
  }
  .orders-li .o-main .img{
    float: left;
    width: 35%;
  }
  .orders-li .o-main .img img{
    width: 100%;
    height: 80px;
  }
  .orders-li .o-main .info h3{
    margin: 0;
    font-size: 14px;
    font-weight: normal;
    height: 40px;
  }
  .orders-li .o-main .info .price{
    font-size: 14px;
  }
  .orders-li .o-main .info .price .sp2{
    color: #ED6A0C;
  }
  .orders-li .o-main .info .pay-price{
    font-size: 14px;
    margin-top: 5px;
  }
  .orders-li .o-main .info .pay-price .p-sp-2{
    float: right;
  }
  .orders-li .o-bottom{
    overflow: hidden;
    margin-top: 10px;
  }
  .orders-li .o-bottom .o-wl{
    float: right;
    font-size: 14px;
    border:1px solid #D3D3D3;
    border-radius: 15px;
    padding: 5px 20px;
    color:#6D6D6D;
    margin-left: 12px;
  }
  .item-time{
    font-size: 13px;
    color:#646566;
  }
  .o-l-b{
    margin-top: 10px;
  }
  .order-show{
    overflow: hidden;
  }
  .order-show-li{
    background: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 10px;
  }
  .order-show-li .h3{
    margin: 0;
    font-size: 14px;
    padding-bottom: 5px;
    color:#323233;
  }
  .order-show-li .o-s-li-m{
    font-size: 14px;
  }
  .order-show-li .o-s-li-m span{
    display: block;
    line-height: 23px;
  }

  .order-show-li .o-main{
    overflow: hidden;
    margin-top: 5px;
  }
  .order-show-li .o-main .img{
    float: left;
    width: 35%;
  }
  .order-show-li .o-main .img img{
    width: 100%;
    height: 80px;
  }
  .order-show-li .o-main .info{
    float: right;
    width: 60%;
    margin-left: 5%;
  }
  .order-show-li .o-main .info h3{
    margin: 0;
    font-size: 14px;
    font-weight: normal;
    height: 40px;
  }
  .order-show-li .o-main .info .price{
    font-size: 14px;
  }
  .order-show-li .o-main .info .price .sp2{
    color:#646566;
  }
  .order-show-li .o-main .info .pay-price{
    font-size: 14px;
    margin-top: 5px;
  }
  .order-show-li .o-main .info .pay-price .p-sp-2{
    float: right;
  }
  .order-show-li .o-s-address{
    font-size: 14px;
  }
  .order-show-li .o-s-address p{
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/orders/index.vue